import React from 'react';

const SearchIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.41666 2.33268C4.16149 2.33268 2.33332 4.16085 2.33332 6.41602C2.33332 8.67118 4.16149 10.4993 6.41666 10.4993C8.67182 10.4993 10.5 8.67118 10.5 6.41602C10.5 4.16085 8.67182 2.33268 6.41666 2.33268ZM1.16666 6.41602C1.16666 3.51652 3.51716 1.16602 6.41666 1.16602C9.31615 1.16602 11.6667 3.51652 11.6667 6.41602C11.6667 9.31551 9.31615 11.666 6.41666 11.666C3.51716 11.666 1.16666 9.31551 1.16666 6.41602Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.3 9.29976C9.52781 9.07195 9.89716 9.07195 10.125 9.29976L12.6625 11.8373C12.8903 12.0651 12.8903 12.4344 12.6625 12.6622C12.4347 12.89 12.0653 12.89 11.8375 12.6622L9.3 10.1247C9.0722 9.89691 9.0722 9.52757 9.3 9.29976Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SearchIcon;
